import React, { FC } from 'react'
import useScript from 'hooks/loadScript'
import styles from './Recaptcha.module.scss'
import SALink from 'components/SALink'

const { RECAPTCHA_WEBSITE_KEY_ID } = process.env

/* NOTES -> `docs/services/Captcha.md` */
declare let grecaptcha
const SCRIPT_URL = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_WEBSITE_KEY_ID ||
  ''}&trustedtypes=true`

export const getCaptchaToken = async (action: string): Promise<string> => {
  return new Promise((resolve) => {
    grecaptcha.enterprise.ready(() => {
      grecaptcha.enterprise
        .execute(RECAPTCHA_WEBSITE_KEY_ID, {
          action,
        })
        .then((token) => {
          return resolve(token)
        })
    })
  })
}
type RecaptchaProps = {
  customId?: string // Future Proof for MULTIPLE captcha's
}

const Recaptcha: FC<RecaptchaProps> = (props) => {
  const { customId } = props
  const widgetId = customId || 'recaptcha'
  useScript({
    async: true,
    name: 'captcha-script',
    src: SCRIPT_URL,
  })

  return (
    <div id={widgetId} className={styles.recaptchaContainer}>
      <p>
        {`This site is protected by reCAPTCHA and the Google `}
        <SALink
          className={styles.copyrightRecaptchaLink}
          target='_blank'
          data-gtm-event='footer'
          rel='noopener noreferrer'
          href='https://policies.google.com/privacy'
          title='Privacy Policy'
        >
          Privacy Policy
        </SALink>
        {` and `}
        <SALink
          className={styles.copyrightRecaptchaLink}
          target='_blank'
          data-gtm-event='footer'
          rel='noopener noreferrer'
          href='https://policies.google.com/terms'
          title='Terms of Service'
        >
          Terms of Service
        </SALink>
        {` apply.`}
      </p>
    </div>
  )
}

export default Recaptcha
